import { Controller } from "@hotwired/stimulus"
import { CHANGE_EVENT, setPreference, storedPreference } from "../lib/admin_theme"

// Admin topbar theme menu (Light | Dark | System). The icon on the button comes
// from html[data-theme-pref]; this keeps the options' pressed state in step for
// keyboard and screen-reader users, including changes from other tabs.
// Opening and closing on outside click / Escape is dropdown_controller.js.
export default class extends Controller {
  static targets = ["option"]

  connect() {
    this.sync = this.sync.bind(this)
    document.addEventListener(CHANGE_EVENT, this.sync)
    this.sync()
  }

  disconnect() {
    document.removeEventListener(CHANGE_EVENT, this.sync)
  }

  select(event) {
    setPreference(event.currentTarget.value)
    this.element.removeAttribute("open")
    this.element.querySelector("summary").focus()
  }

  // Prefer what was applied over what's stored: with storage blocked the
  // choice still applies to this page but never reaches localStorage.
  sync(event) {
    const preference = event?.detail?.preference ?? document.documentElement.dataset.themePref ?? storedPreference()
    this.optionTargets.forEach((option) => {
      option.setAttribute("aria-pressed", option.value === preference)
    })
  }
}
